import React from "react"
import Container from "../../atoms/Container"
import Form from "../Form"
import "./Contactgegevens.css"

export default function Contactgegevens({ block }) {
  return (
    <Container>
      <div className="vt-whitespace-container"></div>
      <div className="vt-contactgegevens-container">
        <div className="vt-contactgegevens-left">
          <h5>{block.subtitel}</h5>
          <h2>{block.titel}</h2>
          <div dangerouslySetInnerHTML={{ __html: block.tekst }}></div>
          <div className="vt-contactgegevens-linkjes">
            <div className="vt-contactgegevens-linkjes-email">
              <img src={block.email.icon.localFile.publicURL} />
              <a href={block.email.link}>
                <h3 className="vt-contactgegevens-linkjes-h3">
                  {block.email.label}
                </h3>
              </a>
            </div>
            <div className="vt-contactgegevens-linkjes-telefoonnummer">
              <img src={block.telefoonnummer.icon.localFile.publicURL} />
              <a href={block.telefoonnummer.link}>
                <h3 className="vt-contactgegevens-linkjes-h3">
                  {block.telefoonnummer.label}
                </h3>
              </a>
            </div>
            <div className="vt-contactgegevens-linkjes-whatsapp">
              <img src={block.whatsapp.icon.localFile.publicURL} />
              <a href={block.whatsapp.link}>
                <h3 className="vt-contactgegevens-linkjes-h3">
                  {block.whatsapp.label}
                </h3>
              </a>
            </div>
          </div>
        </div>
        <div className="vt-contactgegevens-right">
          <Form id={block.formulierId}></Form>
        </div>
      </div>
    </Container>
  )
}
